export const getDomainFromEmail = email => email.split('@')[1] || null;
